module.exports = __webpack_public_path__ + "img/75996.5a1a8ff2.svg";